import React from 'react';
import './Services.css';
import ServiceDetail from '../ServiceDetail/ServiceDetail';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useState } from 'react';
import { useEffect } from 'react';
const Services = () => {
      const [serviceData,setServiceData]=useState([])
      const [loading,setLoading] = useState(true);
      useEffect(()=>{
          fetch('https://nameless-caverns-85256.herokuapp.com/newService')
          .then(res=>res.json())
          .then(data=>{
            setServiceData(data)
            setLoading(false)
          })
      },[])
    return (
        <section className="services-container mt-5 service-section">
        <div className="text-center">
            <h1>Provide awesome <span style={{color:'##7AB259'}}>services</span></h1>
        </div>
        <div className="d-flex justify-content-center">
          
        <div className="w-75 row mt-5 pt-5 text-center">
            {
                loading ?<CircularProgress style={{position: 'relative' ,left:'500px',bottom:'100px'}}/> : serviceData.map(service => <ServiceDetail service={service} key={service._id}></ServiceDetail>)
            }
        </div>
    </div>
    </section>
    );
};

export default Services;